module.exports = __webpack_public_path__ + "static/media/facility-02.ed8a253f.jpg";